import { GlobalState, UI } from '@leverege/ui-redux';
import { LinkAction } from "../../routes/index.js";
import Util from "../Util.js";
function create(molten, relationship, {
  actionPath,
  t,
  tf,
  tfIcon
}) {
  // Get parameters
  const {
    blueprint,
    attribute,
    path
  } = relationship;
  const excludeFrom = blueprint.getTagsStartingWith('excludeTempUserManagementFrom:', true);
  const attrExcludeFrom = attribute ? attribute.getTagsStartingWith('excludeTempUserManagementFrom:', true) : [];
  const navSortUsers = blueprint.getTagStartingWith('navSortTempUserManagement:', true) || 'zzz';
  const sectionName = blueprint.getString('tempUserManagementSectionName');
  return LinkAction.create({
    id: `link.${path}.ResourceTemporaryUsers`,
    matches: {
      client: 'ItemScreen',
      objectType: blueprint.type,
      path,
      use: 'navBar'
    },
    name: tf('name'),
    icon: tfIcon('icon'),
    path: actionPath,
    layout: {
      sort: navSortUsers,
      // put at end
      sectionName
    },
    handles: cxt => {
      const aPersona = UI.get(GlobalState.get()).activePersona?.name;
      if (Util.shouldExclude(aPersona, attribute, excludeFrom, attrExcludeFrom)) {
        return false;
      }
      return true;
    }
  });
}
export default {
  create
};